
import ShopItem from "./ShopItem/index.vue";
import { miceService } from "@/service/miceService.js";
import { SmartStorage } from 'smart-core-util';
import { mapMutations, mapGetters } from "vuex";
import { colors } from "@/utils/js/colors.js";
export default {
    name: "ShopList",
    components: {
        ShopItem
    },
    data() {
        return {
            fromXBH: false,
            serviceList: [],
            orderByList: [],
            priceList: [],
            shopList: [],
            showPositionLoad: false,
            isDownLoading: false,
            loading: false,
            finished: false,
            error: false,
            sortShow: false,
            type: "",
            category: [],
            locationFail: false,
            otherList: [],
            child: {},
            queryParams: {}, //请求参数
            params: {
                geo: "", //地理位置
                longitude: "",
                latitude: "",
                orderBy: 1, //排序
                deliveryMode: 0, // 配送⽅式
                newRestaurant: 0, //是否是新店
                isPremium: 0, //是否品牌商家
                invoice: 1, //是否可开发票
                insurance: 0, //是否⽀持⻝安保
                isBookable: 0, //是否支持预定
                costFrom: undefined, //⼈均消费⾦额下限
                costTo: undefined, //⼈均消费⾦额上限
                categoryIds: [], //餐厅分类 ids
                start: 1, //查询起始位置，默认为0
                rankId: undefined //⾸次查询⽆需传⼊，后续需要传⼊前次返回
            }
        };
    },
    computed: {
        ...mapGetters(["eleAddress", "eleKeyword", "isxingbake", "eleRefresh", "eventData", "eleCity"]),
        color() {
            return colors[this.eventData.tenant_code]
        }
    },
    mounted() {
        this.fromXBH = this.iStorage.get("isH5")
        this.queryDict();
        let {tenant_code, hospitalGPS} = this.eventData;
        if(['dscl'].includes(tenant_code) && hospitalGPS) {
            let params = {
                latitude: hospitalGPS.latitude,
                longitude: hospitalGPS.longitude,
                addressName: hospitalGPS.hospitalName,
                city: hospitalGPS.city
            }
            this.complete(params);
        }else if(['dscl'].includes(tenant_code)) {
            this.hasLocationPermission();
        } else {
            this.geolocation();
        }
        this.getEleCategory(); 
        this.getSetting();
        this.getSort();
    },
    watch: {
        eleKeyword: function(val, oldVal) {
            setTimeout(() => {
                this.onLoad(true, 2)
            }, 1)
        },
        eleRefresh: function(val, oldVal) {
            if (val) {
                this.locationFail = false;
                setTimeout(() => {
                    this.params.geo = `${this.eleAddress.longitude},${this.eleAddress.latitude}` //改变搜索的经纬度
                    this.params.longitude = this.eleAddress.longitude
                    this.params.latitude = this.eleAddress.latitude
                    this.onLoad(true, 1);
                }, 1)
            }
        }
    },
    methods: {
        ...mapMutations([
            'SET_ELE_ADDRESS',
            'ELE_LOCAL_ADD',
            'ELE_CITY',
            'ELE_CITY_LIST',
            'ELE_LOCAL_CITY',
            'ELE_KEYWORD',
            'ELE_REFRESH',
            'EVENT'
        ]),
        // 获取分类
        getEleCategory() {
            miceService.getEleCategory({}).then(res => {
                if (res && res.success) {
                    this.category = res.content.shopCategoryList;
                }
            });
        },
        // 获取城市列表
        queryDict() {
            let params = {
                keyCode: "CPC-City",
            };
            miceService.queryDict(params).then((res) => {
                if (res && res.success) {
                    this["ELE_CITY_LIST"](res.content);
                }
            });
        },
        // 获取筛选条件
        getSetting() {
            let tenant_code = this.eventData.tenant_code || "pfizer";
            if(tenant_code == 'eventcool') {
                tenant_code = 'pfizer'
            }
            let params = {
              collection: "cfg-iwaimai-filter-options",
              useCaching: false,
              cachingKey: "",
              filter: {
                tenantCode: {
                  $in: [tenant_code, "*"]
                }
              },
              projection: {
                filters: 1
              }
            };
            miceService.getsettings(params).then(res => {
                if(res && res.success) {
                    let filterOpt = (res.content || {}).filters || [];
                    for(let i = 0; i<filterOpt.length; i++) {
                        if(filterOpt[i].val === 'priceAvgVal') {
                            this.priceList = filterOpt[i].options || []
                        } else if(filterOpt[i].val === 'service') {
                            this.serviceList = filterOpt[i].options || []
                        } else if(filterOpt[i].val === 'sort') {
                            this.orderByList = filterOpt[i].options || []
                        }
                    }
                }
            })
        },
        getSort() {
            let tenant_code = this.eventData.tenant_code || "eventcool";
            // if(tenant_code == 'eventcool') {
            //     tenant_code = 'pfizer'
            // }
            let params = {
                collection: "cfg-iwaimai-sort-options",
                useCaching: false,
                cachingKey: "",
                filter: {
                    tenantCode: { $in: [tenant_code || "*", "*"] } ,
                    eventType: { $in: [this.eventData.typeDictTxt || "*", "*"] },
                    eventStatus: { $in: [this.eventData.statusTxt || "*", "*"] },
                    eventPlace: { $in: ["*", "*"] },
                    "cities.city": {
                        $in: [this.eventData.cityDictVal || "*", "*"],
                    },
                },
                projection: {
                    name: 1,
                    handle: 1,
                    icon: 1,
                    order: 1,
                    id: 1,
                },
            };
            miceService.querySettings(params).then(res => {
                if(res && res.success) {
                    this.otherList = (res.content || []).sort(this.compare("order")); 
                }
            })
        },
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            };
        },
        // 查询是否开启权限
        hasLocationPermission() {
            let _this = this;
            this.iJsBridge.call({
                method: "SMPermission.hasLocationPermission",
                postData: {},
                callback: _this.hasLocationPermissionCallback
            });
        },
        hasLocationPermissionCallback(data) {
            if (data === true || data === "true") {
                this.getLocation();
            } else {
                if(this.eventData.searchGPS) {
                    this.complete(this.eventData.searchGPS);
                } else {
                    this.locationFail = true;
                    this.$toast("定位失败");
                }
            }
        },
        getLocation() {
            this.iJsBridge.call({
                method: "SMAmap.getLocation",
                postData: {},
                callback: this.getLocationCallback
            });
        },
        getLocationCallback(addressInfo) {
            if(typeof(addressInfo) === 'string') {
                addressInfo = JSON.parse(addressInfo)
            }
            console.log(addressInfo, '原生')
            if(addressInfo.lat || addressInfo.lon) {
                let params = {
                    latitude: addressInfo.lat,
                    longitude: addressInfo.lon,
                    addressName: addressInfo.aoiname,
                    city: addressInfo.city || addressInfo.province
                }
                let searchGPS = this.eventData.searchGPS
                if(searchGPS && (params.city != searchGPS.city)) {
                    this.complete(searchGPS);
                } else {
                    this.complete(params)
                }
            } else {
                this.locationFail = true;
                this.$toast("定位失败");
            }
        },
        //定位
        geolocation() {
            this.showPositionLoad = true; //显示定位中
            let _this = this;
            /* global AMap */
            var map = new AMap.Map("container", {
                resizeEnable: true
            });
            let searchGPS = _this.eventData.searchGPS;

            AMap.plugin(["AMap.Geolocation"], function () {
                var geo = new AMap.Geolocation({
                    useNative: true,
                    timeout: 10000,
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    extensions: 'all'
                });
                map.addControl(geo);
                geo.getCurrentPosition(function (status, result) {
                    _this.showPositionLoad = false;
                    console.log('定位信息1',result)
                    if (status == "complete") {
                        let params = {
                            latitude: result.position.lat,
                            longitude: result.position.lng,
                            city: result.addressComponent.city || result.addressComponent.province,
                            addressName: (result.pois || [{name: ''}])[0].name || result.formattedAddress
                        }
                        console.log('定位信息',result)
                        if(searchGPS && (params.city != searchGPS.city)) {
                            _this.complete(searchGPS);
                        } else {
                            _this.complete(params)
                        }
                    } else {
                        if(searchGPS) {
                            _this.complete(searchGPS);
                        } else {
                            _this.locationFail = true;
                            console.log(result, "定位失败")
                            _this.$toast("定位失败");
                        }
                    }
                });
            });
        },
        // 定位成功
        complete(result) {
            let address = {
                latitude: result.latitude,
                longitude: result.longitude,
                addressName: result.addressName,
                cityName: result.city
            }
            console.log('address',address);
            this['ELE_CITY'](result.city)
            this['ELE_LOCAL_CITY'](result.city)
            let params = {
                latitude: address.latitude,
                longitude: address.longitude,
            }
            if(['roche'].includes(this.eventData.tenant_code)){
                params.SourceCode = 'ELE'
            }
            miceService.getNearUserAddress(params).then(res => {
                if(res && res.success) {
                    if(res.content.addressList) {
                        address = res.content.addressList[0]
                    }
                    this.params = {
                        ...this.params,
                        geo: `${address.longitude},${address.latitude}`,
                        longitude: address.longitude,
                        latitude: address.latitude
                    }
                    this['SET_ELE_ADDRESS'](address)
                    this['ELE_LOCAL_ADD'](address)
                    this.onLoad(false, 3);
                }
            })
        },
        initData() {
            //重置
            this.params = {
                geo: `${this.eleAddress.longitude},${this.eleAddress.latitude}`, //地理位置
                longitude: this.eleAddress.longitude,
                latitude: this.eleAddress.latitude,
                orderBy: 1, //排序
                deliveryMode: 0, // 配送⽅式
                newRestaurant: 0, //是否是新店
                isPremium: 0, //是否品牌商家
                invoice: 1, //是否可开发票
                insurance: 0, //是否⽀持⻝安保
                isBookable: 0,
                costFrom: undefined, //⼈均消费⾦额下限
                costTo: undefined, //⼈均消费⾦额上限
                categoryIds: [], //餐厅分类 ids
                start: 1, //查询起始位置，默认为0
                rankId: undefined //⾸次查询⽆需传⼊，后续需要传⼊前次返回
            }
            this.queryParams = _.cloneDeep(this.params)
        },
        clearEleKeyword() {
            this['ELE_KEYWORD']('')
        },
        closePage() {
            if(this.eventData.isWeb) {
                window.location.href = SmartStorage.get('Uris').Uris['webapp-imeal']
            } else {
                if(this.child.id) {
                    let categoryIds = this.params.categoryIds
                    if (categoryIds.includes(this.child.id)) {
                        let index = categoryIds.indexOf(this.child.id)
                        categoryIds.splice(index, 1)
                        this.params.categoryIds = categoryIds
                    }
                    this.child = {};
                    this.onLoad(true);
                } else {
                    this.iJsBridge.setResult({});
                    this.iJsBridge.close();
                }
            }
        },
        // 打开筛选
        openFilter(type) {
            if (!this.eleAddress.addressName) {
                this.$toast('请选择配送地址')
                return
            }
            this.queryParams = _.cloneDeep(this.params) //记录之前的筛选条件，没点击完成就重置原先的筛选条件
            this.type = type;
            this.sortShow = true;
        },
        // 关闭筛选
        closeFilter() {
            this.params = _.cloneDeep(this.queryParams)
            this.sortShow = false;
            this.type = "";
        },

        setChild(item) {
            switch(item.handle) {
                case "goDetail": 
                    this.goDetail(item)
                    break
                case "goFruits": 
                    this.goFruits()
                    break
                case "goMeiTuan":
                    this.goMeiTuan()
                    break
            }
        },
        goDetail(item) {
            this.child = item;
                let categoryIds = this.params.categoryIds
                if(!categoryIds.includes(item.id)) {
                    let result = _.concat(categoryIds, item.id)
                    this.params.categoryIds = result
                }
                this.onLoad(true);
        },
        goFruits() {
            if (!this.eleAddress.addressName) {
                this.$toast('请选择配送地址')
                return
            }
            new Promise((resolve, reject) => {
                let Uris = {
                    Uris: {
                        gateway: SmartStorage.get('Uris').Uris.gateway
                    }
                }
                this.iJsBridge.call({
                    method: "SMDataStorage.setItem",
                    postData: { ["Uris"]: JSON.stringify(Uris) },
                });
                this.iJsBridge.call({
                    method: "SMDataStorage.setItem",
                    postData: { ["eventData"]: JSON.stringify(this.eventData) },
                });
                if(this.eventData.itemId) {
                    resolve()
                } else {
                    let params = {
                        isDelete: 1,
                        ProposalId: this.eventData.proposalId,
                    }
                    miceService.saveTakeOutItem(params).then(res => {
                        if(res && res.success) {
                            let eventData = {
                                ...this.eventData,
                                itemId: res.content
                            }
                            this['EVENT'](eventData)
                            resolve()
                        }
                    })
                }
            }).then(() => {
                // 水果跳转H5
                let params = {
                    ItemId: this.eventData.itemId,
                    latitude: this.params.latitude,
                    longitude: this.params.longitude,
                    building: this.eleAddress.addressName,
                }
                miceService.newRetail(params).then(res => {
                    if(res && res.success) {
                        this.openNewWebSiteForResult(res.content)
                    }
                })
            })
        },
        goMeiTuan() {
            const params =  {
                itemId: this.eventData.itemId || this.iStorage.get('orderDetail').itemId,
                SourceCode: "DianPing"
            }
            miceService.GetDianPingUrl(params).then(res => {
                if(res && res.success) {
                    this.openNewWebSiteForResult(res.content, () => {
                        miceService.refreshDianPingOrder(params)
                    })
                }
            })
        },
        openNewWebSiteForResult(url, callback) {
            if(this.fromXBH){
                window.location.href = url
                return
            }
            const options = {
                method: "SMGeneral.openNewWebSiteForResult",
                postData: {
                    loadUrl: url,
                    browserMode: {
                        navBarVisibilty: true,
                        titleTextColor: this.color,
                        navBackgroundColor: this.color
                    }
                },
                callback: async() => {
                    callback && callback();
                }
            };
            this.iJsBridge.call(options);
        },
        // 上拉刷新
        onDownRefresh() {
            this.isDownLoading = true; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
            this.onLoad(true, 4); // 加载数据
        },
        // 请求列表
        onLoad(fresh, num) {
            let params = _.cloneDeep(this.params)
            this.loading = true;
            if (fresh) {
                params.start = 1
                params.rankId = undefined
                if(document.querySelector(".shopListContent")) {
                    document.querySelector(".shopListContent").scrollTop = 0
                }
            }
            if(this.eleKeyword) {
                params.keyword = this.eleKeyword
            }
            if(this.isxingbake) {
                params.isPremium = 1
                params.invoice = 0
            }
            if(!params.categoryIds.length) {
                delete params.categoryIds
            }
            if(this.eleAddress.addressId) {
                params.AddressId = this.eleAddress.addressId
            } else {
                params.CityName = this.eleCity
            }
            this.getEleList(params, fresh)
        },
        getEleList(params, fresh) {
            params.ProposalId = this.eventData.proposalId;
            miceService.getEleShopList(params).then(res => {
                if(res.code == '405'){
                    this.$toast(res.msg);
                }
                if (res && res.success) {
                    let shopListData = res.content.shopListData || {dataList: []}
                    let dataList = shopListData.dataList || []
                    this.shopList = fresh ? dataList : this.shopList.concat(dataList);
                    this.loading = false;
                    this.isDownLoading = false;
                    this.finished = !res.content.hasNext;
                    let start = params.start
                    this.params = {
                        ...this.params,
                        rankId: res.content.rankId,
                        start: start + 1
                    }
                    this['ELE_REFRESH'](false)
                }
            })
        },
        goSearch() {
            if (!this.eleAddress.addressName) {
                this.$toast('请选择配送地址')
                return
            }
            this.$router.push('/ele/shopSearch')
        },
        // 选择地址
        goAddress() {
            this.sortShow = false
            this.$router.push("/ele/address");
        },
        // 排序
        setOrderBy(item) {
            this.sortShow = false
            this.params = {
                ...this.params,
                orderBy: item.val
            }
            this.onLoad(true)
        },
        // 商家分类
        setCategory(item) {
            let categoryIds = this.params.categoryIds
            if (categoryIds.includes(item.id)) {
                let index = categoryIds.indexOf(item.id)
                categoryIds.splice(index, 1)
                this.params.categoryIds = categoryIds
            } else {
                let result = _.concat(categoryIds, item.id)
                this.params.categoryIds = result
            }
        },
        // 商家服务
        setService(item) {
            let obj = this.params
            obj[item.val] = +!obj[item.val]
            this.params = obj
        },
        // 筛选提交
        submit() {
            let categoryIds = this.params.categoryIds
            if (!categoryIds.includes(this.child.id)) {
                this.child = {}
            }
            this.sortShow = false;
            this.type = "";
            this.onLoad(true, 5);
        },
        // 筛选重置
        reset() {
            this.initData();
            this.child = {};
            this.onLoad(true, 6);
        },
        computeClass(item) {
            if(this.params.costFrom===undefined && this.params.costTo===undefined) {
                return false
            }
            if(item.costFrom === this.params.costFrom) {
                return true
            }
        },
        choosePrice(item) {
            if(item.costFrom === this.params.costFrom) {
                this.params = {
                    ...this.params,
                    costFrom: undefined,
                    costTo: undefined
                }
            } else {
                this.params = {
                    ...this.params,
                    costFrom: item.costFrom,
                    costTo: item.costTo
                }
            }
        },
    },
    // 进入商家详情后返回  列表位置不变动
    beforeRouteLeave(to, from, next) {
        if (document.querySelector(".shopListContent")) {
            this.scrollTop = document.querySelector(
                ".shopListContent"
            ).scrollTop;
        }
        next();
    },
    beforeRouteEnter(to, from, next) {
        if (to.query.refresh) {
            next()
        } else {
            next(vm => {
                if (document.querySelector(".shopListContent")) {
                    document.querySelector(".shopListContent").scrollTop =
                        vm.scrollTop;
                }
            });
        }
    }
};